import React, { useState, useMemo, useEffect, useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import WorkflowsGrid from './WorkflowsGrid';
import RecipesGrid from './RecipesGrid';
import CommissionScanHistory from '../commissionscan/CommissionScanHistory';
import CommissionScanUpload from '../commissionscan/CommissionScanUpload';
import COIScanHistory from '../coiscan/COIScanHistory';
import COIScanUpload from '../coiscan/COIScanUpload';
import DriverLicenseScanHistory from '../driverlicensescan/DriverLicenseScanHistory';
import DriverLicenseScanUpload from '../driverlicensescan/DriverLicenseScanUpload';
import { motion } from 'framer-motion';
import { FiZap, FiSearch, FiPhone, FiFileText, FiTrendingUp, FiHash, FiRefreshCw, FiChevronLeft, FiThumbsUp, FiClock, FiStar, FiCopy, FiBarChart2, FiMic, FiGrid, FiMapPin, FiLock, FiEdit3, FiAlertTriangle, FiCheck, FiArrowRight, FiPlus, FiChevronDown, FiDownload, FiCalendar, FiUser, FiBox, } from 'react-icons/fi';
import { useMarketplace } from '../../hooks/useMarketplace';
import { useAuth } from '../auth/AuthContext';
import { useFeedbackPanel } from '../../context/FeedbackPanelContext';
import type { MarketplaceModuleResponse, MarketplaceReview } from '../../services/marketplaceService';
import '../../styles/AmpsGridPage.css';
import '../../styles/MarketplacePage.css';
import ToolboxLanding, { recordToolOpen } from './ToolboxLanding';
import InvoiceScanUpload from '../invoicescan/InvoiceScanUpload';
import InvoiceScanHistory from '../invoicescan/InvoiceScanHistory';
import LossRunScanUpload from '../lossrunscan/LossRunScanUpload';
import LossRunScanHistory from '../lossrunscan/LossRunScanHistory';
import MTMScanUpload from '../mtmscan/MTMScanUpload';
import MTMScanHistory from '../mtmscan/MTMScanHistory';
import VehiclePrefillSearch from '../vehicleprefill/VehiclePrefillSearch';
import VehiclePrefillHistory from '../vehicleprefill/VehiclePrefillHistory';
import MVRScanUpload from '../mvrscan/MVRScanUpload';
import MVRScanHistory from '../mvrscan/MVRScanHistory';
import MVRUpload from '../mvr/MVRUpload';
import MVRHistory from '../mvr/MVRHistory';
import UpsellSummaryView from '../upsellindicator/UpsellSummaryView';
import UpsellIndicatorHistory from '../upsellindicator/UpsellIndicatorHistory';
import NaicsClassificationSearch from '../naicsclassification/NaicsClassificationSearch';
import NaicsClassificationHistory from '../naicsclassification/NaicsClassificationHistory';
import ValChoiceClassificationSearch from '../valchoiceclassification/ValChoiceClassificationSearch';
import ValChoiceClassificationHistory from '../valchoiceclassification/ValChoiceClassificationHistory';
import CarrierFinderChat from '../carrierfinder/CarrierFinderChat';
import CarrierFinderConfigure from '../carrierfinder/CarrierFinderConfigure';
import CarrierFinderHistory from '../carrierfinder/CarrierFinderHistory';
import type { ChatMessage } from '../carrierfinder/CarrierFinderPage';
import HomeOwnersSearch from '../homeowners/HomeOwnersSearch';
import HomeOwnersHistory from '../homeowners/HomeOwnersHistory';
import FenrisPersonalLineSearch from '../fenrispersonalline/FenrisPersonalLineSearch';
import FenrisPersonalLineHistory from '../fenrispersonalline/FenrisPersonalLineHistory';
import FenrisDriverVehicleSearch from '../fenrisdrivervehicle/FenrisDriverVehicleSearch';
import FenrisDriverVehicleHistory from '../fenrisdrivervehicle/FenrisDriverVehicleHistory';
import DataEnrichmentCommercialSearch from '../dataenrichmentcommercial/DataEnrichmentCommercialSearch';
import DataEnrichmentCommercialHistory from '../dataenrichmentcommercial/DataEnrichmentCommercialHistory';
import AcordSmartScanUpload from '../acordsmartscan/AcordSmartScanUpload';
import AcordSmartScanHistory from '../acordsmartscan/AcordSmartScanHistory';
import PremiumFinanceScanUpload from '../premiumfinancescan/PremiumFinanceScanUpload';
import PremiumFinanceScanHistory from '../premiumfinancescan/PremiumFinanceScanHistory';
import PolicyComparisonUpload from '../policycomparison/PolicyComparisonUpload';
import PolicyComparisonHistory from '../policycomparison/PolicyComparisonHistory';
import PolicySummaryUpload from '../policycomparison/PolicySummaryUpload';
import PolicySummaryHistory from '../policycomparison/PolicySummaryHistory';
import SonantLandingView from '../sonant/SonantLandingView';
import SonantHistoryView from '../sonant/SonantHistoryView';
import LinqsESignatureView from '../linqsesignature/LinqsESignatureView';
import LinqsESignatureHistory from '../linqsesignature/LinqsESignatureHistory';
import DataQualityScanUpload from '../dataqualityscan/DataQualityScanUpload';
import DataQualityScanHistory from '../dataqualityscan/DataQualityScanHistory';
import RateRiskAppetiteSearch from '../rateriskappetite/RateRiskAppetiteSearch';
import RateRiskAppetiteHistory from '../rateriskappetite/RateRiskAppetiteHistory';
import { getModuleIcon, getCatColor, isCustomSvgIcon } from './moduleIconUtils';
export type Module = MarketplaceModuleResponse;
export type ActiveTab = 'premade' | 'published' | 'profile' | 'ai-modules' | 'public' | 'workflows' | 'recipes';
const TAB_LOOKUP: Record<string, ActiveTab> = {
    published: 'published', profile: 'profile', 'ai-modules': 'ai-modules',
    public: 'public', workflows: 'workflows', recipes: 'recipes',
};
export { getModuleIcon, getCatColor };
const DETAIL_TABS = ['Use it', 'History', 'Overview', 'Documentation'];
function renderMarkdown(raw: string): React.ReactNode {
    const text = raw.replace(/\\n/g, '\n');
    const lines = text.split('\n');
    const elements: React.ReactNode[] = [];
    let listItems: string[] = [];
    let i = 0;
    const flushList = (key: string) => {
        if (listItems.length === 0)
            return;
        elements.push(<ul key={key} className="mkt-md__list">
        {listItems.map((item, j) => (<li key={j} className="mkt-md__list-item">
            {item}
          </li>))}
      </ul>);
        listItems = [];
    };
    while (i < lines.length) {
        const line = lines[i];
        if (line.startsWith('## ')) {
            flushList(`list-${i}`);
            elements.push(<h2 key={i} className="mkt-md__h2" style={{ margin: i === 0 ? '0 0 8px' : '22px 0 8px' }}>
          {line.slice(3)}
        </h2>);
        }
        else if (line.startsWith('### ')) {
            flushList(`list-${i}`);
            elements.push(<h3 key={i} className="mkt-md__h3">
          {line.slice(4)}
        </h3>);
        }
        else if (line.startsWith('- ')) {
            listItems.push(line.slice(2));
        }
        else if (line.trim() === '') {
            flushList(`list-${i}`);
        }
        else {
            flushList(`list-${i}`);
            elements.push(<p key={i} className="mkt-md__p">
          {line}
        </p>);
        }
        i++;
    }
    flushList('list-end');
    return <>{elements}</>;
}
const fmtPrice = (p?: string) => (p || '').replace(/\.00(?=\/|$|\s)/, '');
const ModuleCard: React.FC<{
    module: Module;
    onClick: () => void;
    isPublishedView?: boolean;
}> = ({ module, onClick, isPublishedView }) => {
    const Icon = getModuleIcon(module);
    const iconColor = module.iconColor || getCatColor(module.category);
    const catColor = getCatColor(module.category);
    const isFree = module.pricingType === 'free';
    return (<motion.div className="mkt-card glass-surface" onClick={onClick} whileHover={{ scale: 1.02, y: -4 }} whileTap={{ scale: 0.98 }} transition={{ duration: 0.2 }} style={{ border: isPublishedView ? '1px solid rgba(16,185,129,0.3)' : undefined }}>
      
      <span className="mkt-card__category" style={{ background: catColor + '1a', color: catColor, border: `1px solid ${catColor}44` }}>
        {module.category === 'AI Scan and Extract Data' ? 'AI Scan'
            : module.category === 'Third Party Data Enrichment Integrations' ? 'Data Enrichment'
                : module.category}
      </span>

      
      <span className="mkt-card__published-badge">
        <FiCheck size={9}/> Published
      </span>

      
      <div className="mkt-card__icon mkt-card__icon--offset" style={{ background: `linear-gradient(135deg, ${iconColor}33, ${iconColor}15)`, color: iconColor }}>
        <Icon size={22}/>
      </div>

      
      <h3 className="mkt-card__name">{module.name}</h3>

      
      <div className="mkt-card__footer">
        <div className="mkt-card__tags">
          {module.tags.slice(0, 2).map((tag) => (<span key={tag} className="mkt-card__tag" style={{ background: catColor + '18', color: catColor, borderColor: catColor + '33' }}>
              #{tag}
            </span>))}
        </div>
        <span className={`mkt-card__price ${module.moduleId === 'linqs-e-signature' ? 'mkt-card__price--paid' : isFree ? 'mkt-card__price--free' : 'mkt-card__price--paid'}`}>
          {module.moduleId === 'linqs-e-signature' ? '$10/month' : isFree ? 'Free' : fmtPrice(module.pricing)}
        </span>
      </div>
    </motion.div>);
};
const PROFILE_TYPE_COLORS: Record<string, string> = { app: '#f97316', skill: '#8b5cf6', agent: '#14b8a6' };
const ProfileModuleCard: React.FC<{
    module: Module;
}> = ({ module }) => {
    const Icon = getModuleIcon(module);
    const rawType = (module.moduleType || 'Skill').toLowerCase();
    const typeColor = PROFILE_TYPE_COLORS[rawType] ?? '#8b5cf6';
    const iconColor = module.iconColor || typeColor;
    const rating = parseFloat(module.satisfaction) || 0;
    const isFree = module.pricingType === 'free';
    const isNew = !module.installed && (module.maturity?.toLowerCase() === 'beta' || module.maturity?.toLowerCase() === 'new');
    return (<div className="mkt-profile-card">
      
      <div className="mkt-profile-card__top-row">
        <div className="mkt-profile-card__icon-circle" style={{ background: iconColor + '22', border: `1.5px solid ${iconColor}38`, color: iconColor }}>
          <Icon size={20}/>
        </div>
        <div className="mkt-util__flex-1">
          <div className="mkt-profile-card__type-row">
            <span style={{ color: typeColor, fontSize: 10, fontWeight: 700, letterSpacing: '0.07em' }}>
              {(module.moduleType || 'SKILL').toUpperCase()}
            </span>
            {isNew && (<span className="mkt-profile-card__new-badge">NEW</span>)}
          </div>
          <h4 className="mkt-profile-card__name">
            {module.name}
          </h4>
        </div>
      </div>

      
      <p className="mkt-profile-card__desc">
        {module.description}
      </p>

      
      <div className="mkt-profile-card__footer">
        {rating > 0 && (<span className="mkt-profile-card__rating">
            <FiStar size={11} className="mkt-icon__star-fill-amber"/> {rating.toFixed(1)}
          </span>)}
        {module.usageLevel && (<span className="mkt-profile-card__usage">↓ {module.usageLevel}</span>)}
        <span className="mkt-profile-card__price" style={{ color: module.moduleId === 'linqs-e-signature' ? 'rgba(255,255,255,0.65)' : isFree ? '#34d399' : 'rgba(255,255,255,0.65)' }}>
          {module.moduleId === 'linqs-e-signature' ? '$10/month' : isFree ? 'Free' : fmtPrice(module.pricing)}
        </span>
      </div>
    </div>);
};
const MyProfileTab: React.FC<{
    modules: Module[];
}> = ({ modules }) => {
    const { user } = useAuth();
    const name = user?.name || 'User';
    const initials = name.split(' ').map((w) => w[0]).filter(Boolean).slice(0, 2).join('').toUpperCase();
    const ownPublished = modules.filter((m) => m.publisher && name && m.publisher.toLowerCase().includes(name.split(' ')[0].toLowerCase()));
    const published = ownPublished.length > 0 ? ownPublished : modules.filter((m) => m.installed);
    const publisher = published[0]?.publisher || name;
    const totalInstalls = published.reduce((sum, m) => {
        const n = parseInt((m.usageLevel || '').replace(/,/g, ''));
        return sum + (isNaN(n) ? 0 : n);
    }, 0);
    const avgRating = published.length > 0
        ? published.reduce((s, m) => s + (parseFloat(m.satisfaction) || 0), 0) / published.length
        : 0;
    return (<div className="mkt-util__stack-20">

      
      <div className="mkt-profile-tab__header-card">
        
        <div className="mkt-profile-tab__avatar">
          {initials || <FiUser size={28}/>}
        </div>

        
        <div className="mkt-util__flex-1">
          <div className="mkt-profile-tab__name-row">
            <h2 className="mkt-profile-tab__name">{name}</h2>
            <span className="mkt-profile-tab__official-badge">
              👑 Official
            </span>
          </div>
          <div className="mkt-profile-tab__meta-row">
            <span className="mkt-profile-tab__publisher">{publisher}</span>
            <FiCheck size={12} className="mkt-icon__check-cyan"/>
            <span className="mkt-profile-tab__official-pill">Official</span>
          </div>
          <p className="mkt-profile-tab__bio">
            Building AI tools for independent insurance agencies.
          </p>
          <div className="mkt-profile-tab__member-since">
            <FiCalendar size={11}/> Member since Jan 2025
          </div>
        </div>

        
        <button className="mkt-profile-tab__edit-btn">
          Edit Profile
        </button>
      </div>

      
      <div className="mkt-profile-tab__stats-row">
        {[
            { icon: <FiBox size={20}/>, value: String(published.length), label: 'PUBLISHED', color: '#8b5cf6' },
            { icon: <FiDownload size={20}/>, value: totalInstalls > 0 ? totalInstalls.toLocaleString() : published.length > 0 ? '—' : '0', label: 'TOTAL INSTALLS', color: '#22d3ee' },
            { icon: <FiStar size={20}/>, value: avgRating > 0 ? `★ ${avgRating.toFixed(1)}` : '—', label: 'AVG RATING', color: '#fbbf24' },
        ].map(({ icon, value, label, color }) => (<div key={label} className="mkt-profile-tab__stat-card">
            <div className="mkt-profile-tab__stat-icon" style={{ background: color + '18', border: `1px solid ${color}30`, color }}>
              {icon}
            </div>
            <div>
              <div className="mkt-profile-tab__stat-value">{value}</div>
              <div className="mkt-profile-tab__stat-label">{label}</div>
            </div>
          </div>))}
      </div>

      
      <div>
        <h3 className="mkt-profile-tab__section-title">
          Published Items
        </h3>
        {published.length === 0 ? (<div className="mkt-profile-tab__empty">
            No published modules yet — install modules from Browse
          </div>) : (<div className="mkt-page__grid">
            {published.map((m) => <ProfileModuleCard key={m.moduleId} module={m}/>)}
          </div>)}
      </div>
    </div>);
};
const MetricCard: React.FC<{
    icon: React.ReactNode;
    value: string;
    label: string;
    color: string;
}> = ({ icon, value, label, color }) => (<div className="mkt-metric-card">
    <div style={{ color }}>{icon}</div>
    <span className="mkt-metric-card__value" style={{ color }}>{value}</span>
    <span className="mkt-metric-card__label">{label}</span>
  </div>);
const StarRating: React.FC<{
    rating: number;
}> = ({ rating }) => (<div className="mkt-star-rating">
    {[1, 2, 3, 4, 5].map((n) => (<FiStar key={n} size={12} style={{ color: n <= rating ? '#fbbf24' : 'var(--border-glass-hover)', fill: n <= rating ? '#fbbf24' : 'none' }}/>))}
  </div>);
const ComingSoon: React.FC = () => (<div className="mkt-coming-soon">
    <div className="mkt-coming-soon__icon-circle">
      <FiClock size={22} className="mkt-icon__clock-purple"/>
    </div>
    <div className="mkt-coming-soon__badge">
      Coming Soon
    </div>
    <p className="mkt-coming-soon__text">
      This feature is not available for the selected module yet.
    </p>
  </div>);
const MKT_DETAIL_TABS = [
    { key: 'Use it', label: 'Use it' },
    { key: 'History', label: 'History' },
    { key: 'Overview', label: 'Overview' },
    { key: 'Documentation', label: 'Documentation' },
    { key: 'Reviews', label: 'Reviews' },
] as const;
type MktDetailTab = typeof MKT_DETAIL_TABS[number]['key'];
const ModuleDetailPage: React.FC<{
    module: Module;
    onBack: () => void;
    isInstalled: boolean;
    isEnabled: boolean;
    onInstallToggle: () => void;
    reviews?: MarketplaceReview[];
    isLoadingDetail?: boolean;
    isProcessing?: boolean;
}> = ({ module, onBack, isInstalled, isEnabled, onInstallToggle, reviews: liveReviews, isLoadingDetail, isProcessing }) => {
    const [activeTab, setActiveTab] = useState('Use it');
    const [cfConversationId, setCfConversationId] = useState<string>(() => crypto.randomUUID());
    const [cfInitialChats, setCfInitialChats] = useState<ChatMessage[]>([]);
    const Icon = getModuleIcon(module);
    const isSvgIcon = isCustomSvgIcon(module);
    const rawType = module.moduleType || 'Skill';
    const typeColor = ({ App: '#f97316', Skill: '#8b5cf6', Agent: '#14b8a6' } as Record<string, string>)[rawType] ?? '#8b5cf6';
    const iconColor = module.iconColor || typeColor;
    const catColor = getCatColor(module.category);
    const isFree = module.pricingType === 'free';
    const isCommissionScan = module.moduleId === 'commission-scan' || module.name?.toLowerCase().includes('commission');
    const isCOIScan = module.moduleId === 'certificate-of-insurance-scan' || module.name?.toLowerCase().includes('certificate of insurance') || module.name?.toLowerCase() === 'coi scan';
    const isDLScan = module.moduleId === 'driver-license-scan' || module.name?.toLowerCase().includes('driver license');
    const isInvoiceScan = module.moduleId === 'invoice-scan' || module.name?.toLowerCase().includes('invoice scan');
    const isLossRunScan = module.moduleId === 'loss-run-scan' || module.name?.toLowerCase().includes('loss run scan');
    const isMTMScan = module.moduleId === 'mtm-scan' || module.name?.toLowerCase().includes('mtm scan') || module.name?.toLowerCase().includes('motor truck mutual');
    const isVehiclePrefill = module.moduleId === 'vehicle-prefill' || module.name?.toLowerCase().includes('vehicle prefill');
    const isMVRScan = module.moduleId === 'mvr-scan' || module.name?.toLowerCase().includes('mvr scan');
    const isMVR = module.moduleId === 'mvr' || (module.name?.toLowerCase() === 'mvr');
    const isUpsellIndicator = module.moduleId === 'upsell-indicator' || module.name?.toLowerCase().includes('upsell indicator');
    const isNaicsClassification = module.moduleId === 'naics-classification' || module.name?.toLowerCase().includes('naics');
    const isHomeOwners = module.moduleId === 'home-owners' || module.name?.toLowerCase().includes('home owner');
    const isFenrisPersonalLine = module.moduleId === 'fenris-personal-line' || module.moduleId === 'data-enrichment-personal-home' || module.name?.toLowerCase().includes('fenris personal line') || module.name?.toLowerCase().includes('data enrichment personal');
    const isFenrisDriverVehicle = module.moduleId === 'data-enrichment-driver-vehicle' || module.name?.toLowerCase().includes('fenris driver') || module.name?.toLowerCase().includes('data enrichment driver');
    const isDataEnrichmentCommercial = module.moduleId === 'data-enrichment-commercial' || module.name?.toLowerCase().includes('data enrichment commercial');
    const isPolicyComparison = module.moduleId === 'policy-comparison' || module.name?.toLowerCase().includes('policy comparison');
    const isPolicySummary = module.moduleId === 'policy-quote-analyzer' || module.name?.toLowerCase().includes('policy-quote-analyzer');
    const isSonant = module.moduleId === 'sonant' || module.name?.toLowerCase().includes('sonant');
    const isLinqsESignature = module.moduleId === 'linqs-e-signature' || module.name?.toLowerCase().includes('linqs e-signature') || module.name?.toLowerCase().includes('linqs-e-signature');
    const isDataQualityScan = module.moduleId === 'data-quality-scan' || module.name?.toLowerCase().includes('data quality');
    const isRateRiskAppetite = module.moduleId === 'rate-risk-appetite' || module.name?.toLowerCase().includes('rate risk appetite');
    const isValChoiceClassification = module.moduleId === 'valchoice-classification' || module.name?.toLowerCase().includes('carrier rating');
    const isMyCarrierFinder = module.moduleId === 'my-carrier-finder' || module.name?.toLowerCase().includes('my carrier finder');
    const isAcordSmartScan = module.moduleId === 'acord-dec-pages-scan' || module.name?.toLowerCase().includes('acord');
    const isPremFiScan = module.moduleId === 'premfi-pfa-scan' || module.name?.toLowerCase().includes('premfi') || module.name?.toLowerCase().includes('pfa scan');
    const visibleTabs = isMyCarrierFinder
        ? [
            { key: 'Use it', label: 'Use it' },
            { key: 'History', label: 'History' },
            { key: 'Configuration', label: 'Configuration' },
            { key: 'Overview', label: 'Overview' },
            { key: 'Documentation', label: 'Documentation' },
            { key: 'Reviews', label: 'Reviews' },
        ]
        : MKT_DETAIL_TABS;
    const tabContent: Record<string, React.ReactNode> = {
        Overview: (<div className="mkt-util__stack-20">
        
        <div className="mkt-detail__overview-panel">
          <p className="mkt-detail__overview-text">
            {module.overview}
          </p>
        </div>

        
        <div className="mkt-detail__metrics-row">
          <MetricCard icon={<FiTrendingUp size={16}/>} value={module.usageLevel} label="Usage" color="var(--accent-green, #34d399)"/>
          <MetricCard icon={<FiZap size={16}/>} value={module.reliability} label="Reliability" color="var(--accent-cyan, #22d3ee)"/>
          <MetricCard icon={<FiClock size={16}/>} value={module.maturity} label="Maturity" color="#fbbf24"/>
          <MetricCard icon={<FiThumbsUp size={16}/>} value={module.satisfaction} label="Satisfaction" color="var(--accent-purple, #8b5cf6)"/>
        </div>

        
        <div className="mkt-util__wrap-gap-6">
          {module.tags.map((tag) => (<span key={tag} className="mkt-detail__tag" style={{ background: catColor + '14', color: catColor, border: `1px solid ${catColor}30` }}>
              #{tag}
            </span>))}
        </div>
      </div>),
        Documentation: (<div className="mkt-detail__doc-panel">
        {renderMarkdown(module.documentation)}
      </div>),
        History: isCommissionScan ? (<CommissionScanHistory />) : isCOIScan ? (<COIScanHistory />) : isDLScan ? (<DriverLicenseScanHistory />) : isInvoiceScan ? (<InvoiceScanHistory />) : isLossRunScan ? (<LossRunScanHistory />) : isMTMScan ? (<MTMScanHistory />) : isVehiclePrefill ? (<VehiclePrefillHistory />) : isMVRScan ? (<MVRScanHistory />) : isMVR ? (<MVRHistory />) : isUpsellIndicator ? (<UpsellIndicatorHistory />) : isNaicsClassification ? (<NaicsClassificationHistory />) : isHomeOwners ? (<HomeOwnersHistory />) : isFenrisPersonalLine ? (<FenrisPersonalLineHistory />) : isFenrisDriverVehicle ? (<FenrisDriverVehicleHistory />) : isDataEnrichmentCommercial ? (<DataEnrichmentCommercialHistory />) : isAcordSmartScan ? (<AcordSmartScanHistory />) : isPremFiScan ? (<PremiumFinanceScanHistory />) : isPolicyComparison ? (<PolicyComparisonHistory />) : isPolicySummary ? (<PolicySummaryHistory />) : isSonant ? (<SonantHistoryView />) : isLinqsESignature ? (<LinqsESignatureHistory />) : isDataQualityScan ? (<DataQualityScanHistory />) : isRateRiskAppetite ? (<RateRiskAppetiteHistory />) : isValChoiceClassification ? (<ValChoiceClassificationHistory />) : isMyCarrierFinder ? (<CarrierFinderHistory onLoadConversation={(convId, chats) => {
                setCfConversationId(convId);
                setCfInitialChats(chats);
                setActiveTab('Use it');
            }}/>) : (<ComingSoon />),
        'Use it': isCommissionScan ? (<CommissionScanUpload onGoToHistory={() => setActiveTab('History')}/>) : isCOIScan ? (<COIScanUpload onGoToHistory={() => setActiveTab('History')}/>) : isDLScan ? (<DriverLicenseScanUpload onGoToHistory={() => setActiveTab('History')}/>) : isInvoiceScan ? (<InvoiceScanUpload onGoToHistory={() => setActiveTab('History')}/>) : isLossRunScan ? (<LossRunScanUpload onGoToHistory={() => setActiveTab('History')}/>) : isMTMScan ? (<MTMScanUpload onGoToHistory={() => setActiveTab('History')}/>) : isVehiclePrefill ? (<VehiclePrefillSearch onGoToHistory={() => setActiveTab('History')}/>) : isMVRScan ? (<MVRScanUpload onGoToHistory={() => setActiveTab('History')}/>) : isMVR ? (<MVRUpload onGoToHistory={() => setActiveTab('History')}/>) : isUpsellIndicator ? (<UpsellSummaryView />) : isNaicsClassification ? (<NaicsClassificationSearch />) : isHomeOwners ? (<HomeOwnersSearch onGoToHistory={() => setActiveTab('History')}/>) : isFenrisPersonalLine ? (<FenrisPersonalLineSearch onGoToHistory={() => setActiveTab('History')}/>) : isFenrisDriverVehicle ? (<FenrisDriverVehicleSearch onGoToHistory={() => setActiveTab('History')}/>) : isDataEnrichmentCommercial ? (<DataEnrichmentCommercialSearch />) : isAcordSmartScan ? (<AcordSmartScanUpload onGoToHistory={() => setActiveTab('History')}/>) : isPremFiScan ? (<PremiumFinanceScanUpload onGoToHistory={() => setActiveTab('History')}/>) : isPolicyComparison ? (<PolicyComparisonUpload onGoToHistory={() => setActiveTab('History')}/>) : isPolicySummary ? (<PolicySummaryUpload onGoToHistory={() => setActiveTab('History')}/>) : isSonant ? (<SonantLandingView />) : isLinqsESignature ? (<LinqsESignatureView />) : isDataQualityScan ? (<DataQualityScanUpload onGoToHistory={() => setActiveTab('History')}/>) : isRateRiskAppetite ? (<RateRiskAppetiteSearch onGoToHistory={() => setActiveTab('History')}/>) : isValChoiceClassification ? (<ValChoiceClassificationSearch />) : isMyCarrierFinder ? (<CarrierFinderChat key={cfConversationId} conversationId={cfConversationId} initialChats={cfInitialChats} onGoToHistory={() => setActiveTab('History')} onGoToConfigure={() => setActiveTab('Configuration')}/>) : (<ComingSoon />),
        Configuration: isMyCarrierFinder ? (<CarrierFinderConfigure />) : null,
        Reviews: isLoadingDetail ? (<p className="mkt-detail__reviews-loading">Loading reviews…</p>) : (<div className="mkt-detail__reviews-list">
        {liveReviews && liveReviews.length > 0 ? liveReviews.map((review, i) => (<div key={i} className="mkt-detail__review-card">
            <div className="mkt-detail__review-header">
              <div className="mkt-detail__review-avatar-row">
                <div className="mkt-detail__review-avatar" style={{ background: `${catColor}2a`, color: catColor }}>
                  {(review.reviewerName || 'A').charAt(0).toUpperCase()}
                </div>
                <div>
                  <div className="mkt-detail__reviewer-name">
                    {review.reviewerName || 'Anonymous'}
                  </div>
                  <StarRating rating={review.rating}/>
                </div>
              </div>
              <span className="mkt-detail__review-date">
                {review.createdAt && !review.createdAt.startsWith('0001') ? new Date(review.createdAt).toLocaleDateString() : ''}
              </span>
            </div>
            <p className="mkt-detail__review-comment">{review.comment}</p>
          </div>)) : (<p className="mkt-detail__reviews-empty">No reviews yet</p>)}
      </div>),
    };
    return (<motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.2 }} className="mkt-detail__page">
      
      <button onClick={onBack} className="mkt-detail__back-btn">
        ← Back to Browse
      </button>

      
      <div className="mkt-detail__header">
        
        <div className="mkt-detail__header-icon" style={{
            background: isSvgIcon ? '#ffffff' : iconColor + '20',
            border: isSvgIcon ? '1px solid rgba(0,0,0,0.08)' : `1.5px solid ${iconColor}38`,
            color: iconColor, padding: isSvgIcon ? 6 : 0,
        }}>
          <Icon size={isSvgIcon ? 44 : 26}/>
        </div>

        
        <div className="mkt-util__flex-1">
          <h2 className="mkt-detail__title">
            {module.name}
          </h2>
          {isLinqsESignature && (<div className="mkt-detail__linqs-note">
              Quickly send the same document for signature over and over.
            </div>)}
          <div className="mkt-detail__publisher-row">
            {module.publisher}
            {module.publisherVerified && <span className="mkt-detail__verified">✓ Verified</span>}
            {module.updatedAt && !module.updatedAt.startsWith('0001') && (<span> · Updated {new Date(module.updatedAt).toLocaleDateString()}</span>)}
          </div>
          <div className="mkt-detail__price-row">
            <span className="mkt-detail__price-text">
              {isLinqsESignature ? '$10/month' : isFree ? 'Free' : fmtPrice(module.pricing)}
            </span>
          </div>
        </div>

      </div>

      
      <div className="mkt-detail__tab-bar">
        {visibleTabs.map(({ key, label }) => (<button key={key} onClick={() => {
                if (key === 'Use it' && isMyCarrierFinder) {
                    setCfConversationId(crypto.randomUUID());
                    setCfInitialChats([]);
                }
                setActiveTab(key);
            }} className="mkt-detail__tab-btn" style={{
                borderBottom: activeTab === key ? `2px solid ${typeColor}` : '2px solid transparent',
                color: activeTab === key ? typeColor : 'var(--text-secondary)',
                fontWeight: activeTab === key ? 600 : 400,
            }}>
            {label}
          </button>))}
      </div>

      
      <motion.div key={activeTab} initial={{ opacity: 0, y: 6 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.15 }} className="mkt-detail__tab-content">
        {tabContent[activeTab]}
      </motion.div>
    </motion.div>);
};
interface MarketplacePageProps {
    onModuleOpen?: (module: Module) => void;
    onModuleClose?: () => void;
}
const MarketplacePage: React.FC<MarketplacePageProps> = ({ onModuleOpen, onModuleClose }) => {
    const { modules: apiModules, selectedModule: hookSelectedModule, reviews, isLoadingModules, isLoadingDetail, isProcessing, fetchModules, selectModule, clearSelection, handleInstall, handleToggle, error, } = useMarketplace();
    const [searchParams, setSearchParams] = useSearchParams();
    const rawTab = searchParams.get('tab');
    const activeTab = (TAB_LOOKUP[rawTab ?? ''] ?? 'premade') as ActiveTab;
    const [activeFilter, setActiveFilter] = useState('All');
    const [typeFilter, setTypeFilter] = useState('All');
    const [searchQuery, setSearchQuery] = useState('');
    const [localSelectedModule, setLocalSelectedModule] = useState<Module | null>(null);
    const displayModule = hookSelectedModule ?? localSelectedModule;
    const dynamicFilters = useMemo(() => {
        const cats = Array.from(new Set(apiModules.map((m) => m.category).filter(Boolean)));
        return ['All', ...cats];
    }, [apiModules]);
    useEffect(() => {
        const isPremade = (activeTab === 'premade' || activeTab === 'published' || activeTab === 'profile' || activeTab === 'ai-modules') ? true : undefined;
        if (!searchQuery) {
            fetchModules(undefined, isPremade);
            return;
        }
        const timer = setTimeout(() => { fetchModules(undefined, isPremade, searchQuery); }, 400);
        return () => clearTimeout(timer);
    }, [activeTab, searchQuery, fetchModules]);
    const filtered = useMemo(() => {
        let list = activeFilter === 'All'
            ? [...apiModules]
            : apiModules.filter((m) => m.category === activeFilter);
        if (activeTab === 'published')
            list = list.filter((m) => m.installed);
        if (activeTab !== 'ai-modules' && typeFilter !== 'All') {
            const t = ({ Skills: 'Skill', Agents: 'Agent', Apps: 'App' } as Record<string, string>)[typeFilter];
            if (t)
                list = list.filter((m) => (m.moduleType || 'Skill') === t);
        }
        if (searchQuery.trim()) {
            const q = searchQuery.toLowerCase();
            list = list.filter((m) => m.name.toLowerCase().includes(q) || m.description.toLowerCase().includes(q) ||
                m.tags.some((tag) => tag.toLowerCase().includes(q)));
        }
        return list.sort((a, b) => a.name.localeCompare(b.name));
    }, [apiModules, activeFilter, activeTab, typeFilter, searchQuery]);
    useEffect(() => {
        setLocalSelectedModule(null);
        clearSelection();
        onModuleClose?.();
        setSearchParams(prev => { const next = new URLSearchParams(prev); next.delete('detail'); return next; });
    }, [rawTab]);
    const handleModuleClick = (mod: Module) => {
        recordToolOpen(mod.moduleId);
        setLocalSelectedModule(mod);
        selectModule(mod.moduleId);
    };
    const handleBack = () => {
        setLocalSelectedModule(null);
        clearSelection();
        onModuleClose?.();
        setSearchParams(prev => { const next = new URLSearchParams(prev); next.delete('detail'); return next; });
    };
    const mod = localSelectedModule ? (displayModule ?? localSelectedModule) : null;
    return (<div className="mkt-page__root">

      
      {mod ? (<div className="mkt-page__detail-wrap">
          <ModuleDetailPage module={mod} onBack={handleBack} isInstalled={mod.installed} isEnabled={mod.isEnabled} onInstallToggle={async () => {
                if (mod.installed)
                    await handleToggle(mod.moduleId, !mod.isEnabled);
                else
                    await handleInstall(mod.moduleId);
            }} reviews={reviews} isLoadingDetail={isLoadingDetail} isProcessing={isProcessing}/>
        </div>) : activeTab === 'premade' ? (<div className="mkt-page__premade-wrap">
          {error && (<div className="mkt-page__error-wrap">
              <div className="mkt-page__error-box">
                <span>{error}</span>
                <button onClick={() => fetchModules(undefined, true)} className="mkt-page__retry-btn">Retry</button>
              </div>
            </div>)}
          <ToolboxLanding modules={apiModules} isLoading={isLoadingModules} onModuleClick={handleModuleClick}/>
        </div>) : (<div className="mkt-page__toolbox-wrap">
      
      <div className="mkt-page__header-wrap">
        <div className="mkt-page__header-row">
          <div className="mkt-page__toolbox-header-icon">
            <FiZap size={15}/>
          </div>
          <h1 className="mkt-page__toolbox-title">
            {activeTab === 'published' ? 'Published'
                : activeTab === 'ai-modules' ? 'AI-Powered Modules'
                    : 'Toolbox'}
          </h1>
        </div>
        <p className="mkt-page__toolbox-subtitle">
          {activeTab === 'published'
                ? 'Modules installed and published to your agency'
                : activeTab === 'ai-modules'
                    ? 'Explore and enable AI modules tailored for insurance workflows'
                    : 'Discover skills and agents built for insurance agencies'}
        </p>
      </div>

      {error && (<div className="mkt-page__error-box mkt-page__error-box--mb">
          <span>{error}</span>
          <button onClick={() => fetchModules(undefined, activeTab === 'published' ? true : undefined, searchQuery || undefined)} className="mkt-page__retry-btn">Retry</button>
        </div>)}

      {activeTab === 'profile' && <MyProfileTab modules={apiModules}/>}

      {activeTab === 'public' && <PublicMarketplaceTab />}

      {activeTab === 'workflows' && <WorkflowsGrid />}
      {activeTab === 'recipes' && <RecipesGrid />}

      
      {(activeTab === 'published' || activeTab === 'ai-modules') && (<>
          
          {activeTab !== 'ai-modules' && (<div className="mkt-page__type-filter-row">
              <div className="mkt-page__search-wrap mkt-page__search-wrap--fixed">
                <FiSearch size={13} className="mkt-page__search-icon"/>
                <input className="mkt-page__search-input" type="text" placeholder="Search modules, skills, agents, apps..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)}/>
              </div>
              {(() => {
                        const base = (() => {
                            let list = activeFilter === 'All' ? [...apiModules] : apiModules.filter(m => m.category === activeFilter);
                            if (activeTab === 'published')
                                list = list.filter(m => m.installed);
                            if (searchQuery.trim()) {
                                const q = searchQuery.toLowerCase();
                                list = list.filter(m => m.name.toLowerCase().includes(q) ||
                                    m.description.toLowerCase().includes(q) ||
                                    m.tags.some(tag => tag.toLowerCase().includes(q)));
                            }
                            return list;
                        })();
                        const typeKeyMap = { Skills: 'Skill', Agents: 'Agent', Apps: 'App' } as Record<string, string>;
                        const tColorMap = { All: '#22d3ee', Skills: '#8b5cf6', Agents: '#14b8a6', Apps: '#f97316' } as const;
                        return (['All', 'Skills', 'Agents', 'Apps'] as const).map((t) => {
                            const color = tColorMap[t];
                            const count = isLoadingModules ? null
                                : t === 'All' ? base.length
                                    : base.filter(m => (m.moduleType || 'Skill') === typeKeyMap[t]).length;
                            const isActive = typeFilter === t;
                            return (<motion.button key={t} onClick={() => setTypeFilter(t)} className="mkt-type-pill" whileHover={{ scale: 1.03 }} whileTap={{ scale: 0.97 }} style={isActive ? {
                                    background: color + '20',
                                    border: `1px solid ${color}55`,
                                    color,
                                    fontWeight: 600,
                                } : undefined}>
                      {t}
                      <span className="mkt-type-pill__count" style={isActive ? { background: color + '30', color } : undefined}>
                        {count ?? '…'}
                      </span>
                    </motion.button>);
                        });
                    })()}
              <span className="mkt-page__result-count">
                {isLoadingModules ? '…' : `${filtered.length} result${filtered.length !== 1 ? 's' : ''}`}
              </span>
            </div>)}

          
          {activeTab === 'ai-modules' && (<>
              <div className="mkt-page__search-wrap">
                <FiSearch size={13} className="mkt-page__search-icon"/>
                <input className="mkt-page__search-input" type="text" placeholder="Search modules..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)}/>
              </div>
              <div className="mkt-page__filters">
                <div className="mkt-page__filter-pills">
                  {dynamicFilters.map((filter) => {
                        const isActive = activeFilter === filter;
                        const color = filter === 'All' ? '#22d3ee' : getCatColor(filter);
                        const label = filter === 'All' ? 'All'
                            : filter === 'AI Scan and Extract Data' ? 'AI Scan'
                                : filter === 'Third Party Data Enrichment Integrations' ? 'Data Enrichment'
                                    : filter;
                        return (<motion.button key={filter} className={`mkt-page__filter-pill${isActive ? ' mkt-page__filter-pill--active' : ''}`} onClick={() => setActiveFilter(filter)} whileHover={{ scale: 1.04 }} whileTap={{ scale: 0.96 }} style={isActive ? { background: color + '20', borderColor: color + '66', color } : undefined}>
                        {label}
                      </motion.button>);
                    })}
                </div>
                <span className="mkt-page__module-count">
                  {isLoadingModules ? '…' : `${filtered.length} module${filtered.length !== 1 ? 's' : ''}`}
                </span>
              </div>
            </>)}

          
          {isLoadingModules ? (<div className="mkt-page__grid">
              {[...Array(8)].map((_, i) => (<div key={i} className="mkt-skeleton mkt-skeleton--relative">
                  <div className="mkt-skeleton__badge"/>
                  <div className="mkt-skeleton__icon"/>
                  <div className="mkt-skeleton__bone mkt-skeleton__bone--title"/>
                  <div className="mkt-skeleton__bone mkt-skeleton__bone--subtitle"/>
                  <div className="mkt-skeleton__footer-row">
                    <div className="mkt-skeleton__bone mkt-skeleton__bone--tag1"/>
                    <div className="mkt-skeleton__bone mkt-skeleton__bone--tag2"/>
                    <div className="mkt-skeleton__bone mkt-skeleton__bone--price"/>
                  </div>
                </div>))}
            </div>) : filtered.length === 0 ? (<div className="mkt-page__empty">
              <FiSearch size={30} className="mkt-icon__empty-search"/>
              <p>{searchQuery.trim() ? `No results for "${searchQuery}"` : activeTab === 'published' ? 'No published modules yet — install from Marketplace' : 'No modules found'}</p>
            </div>) : typeFilter === 'All' && activeTab !== 'ai-modules' ? (<>
              {(['Skills', 'Agents', 'Apps'] as const).map((sectionLabel) => {
                        const sectionType = ({ Skills: 'Skill', Agents: 'Agent', Apps: 'App' } as Record<string, string>)[sectionLabel];
                        const sectionColor = ({ Skills: '#8b5cf6', Agents: '#14b8a6', Apps: '#f97316' } as Record<string, string>)[sectionLabel];
                        const sectionModules = filtered.filter((m) => (m.moduleType || 'Skill') === sectionType);
                        if (sectionModules.length === 0)
                            return null;
                        return (<div key={sectionLabel} className="mkt-page__section-wrap">
                    <h3 className="mkt-page__section-title" style={{ color: sectionColor }}>
                      {sectionLabel}
                      <span className="mkt-section-count">
                        ({sectionModules.length})
                      </span>
                    </h3>
                    <div className="mkt-page__grid">
                      {sectionModules.map((module, i) => (<motion.div key={module.moduleId} initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.03, duration: 0.22 }}>
                          <ModuleCard module={module} onClick={() => handleModuleClick(module)} isPublishedView={activeTab === 'published'}/>
                        </motion.div>))}
                    </div>
                  </div>);
                    })}
            </>) : (<div className="mkt-page__grid">
              {filtered.map((module, i) => (<motion.div key={module.moduleId} initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.03, duration: 0.22 }}>
                  <ModuleCard module={module} onClick={() => handleModuleClick(module)} isPublishedView={activeTab === 'published'}/>
                </motion.div>))}
            </div>)}
        </>)}
    </div>)}

      
    </div>);
};
interface PublishedTool {
    id: string;
    type: number;
    name: string;
    category: string;
    icon: string;
    description: string;
    skills: string;
    kbFileNames: string[];
    createdAt: string;
    creatorName?: string;
}
const TOOL_TYPE_LABEL: Record<number, {
    label: string;
    color: string;
}> = {
    0: { label: 'Skill', color: '#8b5cf6' },
    1: { label: 'Agent', color: '#14b8a6' },
    2: { label: 'Workflow', color: '#22d3ee' },
    3: { label: 'Widget', color: '#f59e0b' },
    4: { label: 'MCP Server', color: '#f97316' },
    5: { label: 'Integration', color: '#ec4899' },
};
function authHeadersTools() {
    return { Authorization: `Bearer ${localStorage.getItem('authToken') || ''}` };
}
const PublicMarketplaceTab: React.FC = () => {
    const [tools, setTools] = useState<PublishedTool[]>([]);
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState('');
    const [selected, setSelected] = useState<PublishedTool | null>(null);
    useEffect(() => {
        setLoading(true);
        fetch(`${(process.env.REACT_APP_Auth_Url || '')}/api/MyTools/published`, { headers: authHeadersTools() })
            .then(r => r.ok ? r.json() : Promise.reject())
            .then(json => {
            const list: any[] = Array.isArray(json) ? json : (json?.data ?? []);
            setTools(list.map((r: any): PublishedTool => {
                let kbFileNames: string[] = [];
                if (Array.isArray(r.kbFileNamesList))
                    kbFileNames = r.kbFileNamesList;
                else if (typeof r.kbFileNames === 'string') {
                    try {
                        kbFileNames = JSON.parse(r.kbFileNames);
                    }
                    catch { }
                }
                else if (Array.isArray(r.kbFileNames))
                    kbFileNames = r.kbFileNames;
                return {
                    id: String(r.id),
                    type: r.type ?? 0,
                    name: r.name ?? '',
                    category: r.category ?? '',
                    icon: r.icon ?? '',
                    description: r.description ?? '',
                    skills: r.skills ?? '',
                    kbFileNames,
                    createdAt: r.updatedAt ?? r.createdAt ?? '',
                    creatorName: r.creatorName ?? '',
                };
            }));
        })
            .catch(() => setTools([]))
            .finally(() => setLoading(false));
    }, []);
    const filtered = tools.filter(t => !search.trim() ||
        t.name.toLowerCase().includes(search.toLowerCase()) ||
        t.description.toLowerCase().includes(search.toLowerCase()));
    if (selected) {
        const typeInfo = TOOL_TYPE_LABEL[selected.type] ?? TOOL_TYPE_LABEL[0];
        return (<motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.2 }}>
        
        <button onClick={() => setSelected(null)} className="mkt-public__back-btn">
          ← Back to Published Skills
        </button>

        
        <div className="mkt-public__header-card" style={{ border: `1px solid ${typeInfo.color}30` }}>
          <div className="mkt-public__header-icon" style={{
                background: `linear-gradient(135deg, ${typeInfo.color}33, ${typeInfo.color}15)`,
                border: `1.5px solid ${typeInfo.color}40`,
                fontSize: selected.icon ? 24 : undefined, color: typeInfo.color,
            }}>
            {selected.icon || '⚡'}
          </div>
          <div className="mkt-util__flex-1">
            <div className="mkt-public__title-row">
              <h1 className="mkt-public__title">{selected.name}</h1>
              <span className="mkt-public__type-badge" style={{ background: typeInfo.color + '18', color: typeInfo.color }}>
                {typeInfo.label}
              </span>
              <span className="mkt-public__published-badge">
                ✓ Published
              </span>
            </div>
            <div className="mkt-public__meta-row">
              {selected.creatorName && <span className="mkt-public__meta-text">by {selected.creatorName}</span>}
              {selected.category && <>
                <span className="mkt-public__dot">·</span>
                <span className="mkt-public__meta-text">{selected.category}</span>
              </>}
              <span className="mkt-public__dot">·</span>
              <span className="mkt-public__free-badge">
                Free
              </span>
            </div>
          </div>
        </div>

        
        <div className="mkt-public__sections">

          
          <div className="mkt-public__two-col">
            {[{ label: 'Name', value: selected.name }, { label: 'Category', value: selected.category }].map(f => (<div key={f.label}>
                <div className="mkt-public__field-label">{f.label}</div>
                <div className="mkt-public__field-box">
                  <span className="mkt-public__field-value" style={{ color: f.value ? 'rgba(255,255,255,0.82)' : 'rgba(255,255,255,0.2)', fontStyle: f.value ? 'normal' : 'italic' }}>{f.value || '—'}</span>
                </div>
              </div>))}
          </div>

          
          <div>
            <div className="mkt-public__field-label">Description</div>
            <div className="mkt-public__desc-box">
              {selected.description
                ? <p className="mkt-public__desc-text">{selected.description}</p>
                : <p className="mkt-public__empty-italic-13">No description provided</p>}
            </div>
          </div>

          
          <div>
            <div className="mkt-public__field-label">Skills</div>
            <div className="mkt-public__skills-box">
              {selected.skills && selected.skills.trim()
                ? <ul className="mkt-public__skills-list">{selected.skills.split('\n').map(s => s.trim()).filter(Boolean).map((s, i) => (<li key={i} className="mkt-public__skills-item">{s}</li>))}</ul>
                : <p className="mkt-public__empty-italic-13">No skills listed</p>}
            </div>
          </div>

          
          <div>
            <div className="mkt-public__field-label">Knowledge Base</div>
            {selected.kbFileNames.length > 0
                ? <div className="mkt-util__wrap-gap-6">
                  {selected.kbFileNames.map(f => (<span key={f} className="mkt-public__kb-chip">
                      📎 {f}
                    </span>))}
                </div>
                : <div className="mkt-public__kb-empty-box">
                  <p className="mkt-public__empty-italic-12">No knowledge base files attached</p>
                </div>}
          </div>

        </div>
      </motion.div>);
    }
    return (<div className="mkt-public__list-wrap">
      
      <div className="mkt-util__mb-16">
        <h2 className="mkt-public__header-title">
          Published Skills
        </h2>
        <p className="mkt-public__header-subtitle">
          Community-built tools reviewed and approved by Momentum AMP
        </p>
      </div>

      
      <div className="mkt-page__search-wrap mkt-util__mb-16">
        <FiSearch size={13} className="mkt-page__search-icon"/>
        <input className="mkt-page__search-input" type="text" placeholder="Search published skills..." value={search} onChange={e => setSearch(e.target.value)}/>
      </div>

      {loading ? (<div className="mkt-page__grid">
          {[...Array(6)].map((_, i) => (<div key={i} className="mkt-skeleton mkt-skeleton--relative">
              <div className="mkt-skeleton__icon"/>
              <div className="mkt-skeleton__bone mkt-skeleton__bone--pub-title" style={{ animationDelay: `${i * 0.05}s` }}/>
              <div className="mkt-skeleton__bone mkt-skeleton__bone--pub-sub" style={{ animationDelay: `${i * 0.05 + 0.1}s` }}/>
            </div>))}
        </div>) : filtered.length === 0 ? (<div className="mkt-page__empty">
          <FiSearch size={30} className="mkt-icon__empty-search"/>
          <p>{search.trim() ? `No results for "${search}"` : 'No published skills yet'}</p>
        </div>) : (<div className="mkt-page__grid">
          {filtered.map((tool, i) => {
                const typeInfo = TOOL_TYPE_LABEL[tool.type] ?? TOOL_TYPE_LABEL[0];
                return (<motion.div key={tool.id} className="mkt-card glass-surface" onClick={() => setSelected(tool)} whileHover={{ scale: 1.02, y: -4 }} whileTap={{ scale: 0.98 }} initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.03, duration: 0.22 }}>
                
                <span className="mkt-card__category" style={{
                        background: typeInfo.color + '1a',
                        color: typeInfo.color,
                        border: `1px solid ${typeInfo.color}44`,
                    }}>
                  {typeInfo.label}
                </span>

                
                <div className="mkt-card__icon mkt-public__card-icon-size" style={{
                        background: `linear-gradient(135deg, ${typeInfo.color}33, ${typeInfo.color}15)`,
                        color: typeInfo.color,
                    }}>
                  {tool.icon || '⚡'}
                </div>

                
                <h3 className="mkt-card__name">{tool.name}</h3>

                
                {tool.description && (<p className="mkt-public__card-desc">
                    {tool.description}
                  </p>)}

                
                <div className="mkt-card__footer mkt-card__footer--mt10">
                  {tool.creatorName ? (<span className="mkt-public__card-creator">
                      by {tool.creatorName}
                    </span>) : <span />}
                  <span className="mkt-card__price mkt-card__price--free">Free</span>
                </div>
              </motion.div>);
            })}
        </div>)}
    </div>);
};
export default MarketplacePage;
